// Vendor
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import MultiTab, {
  TabBody,
  TabContent,
  TabHeader,
  TabTitle
} from 'src/components/molecules/MultiTab/MultiTab';
import { ListView as ViewPage } from 'src/components/templates';
import { MyWorkPerformancePage } from '../MyWorkPerformancePage';

// Redux
import useRole from 'src/features/auth/hooks/useUserRoles';
import {
  getPendingReviewEntryThunk,
  getSocketTokenThunk,
  getSpecialtyQueuePendingCountThunk,
  selectors,
  useSpecialtyQueueAccess
} from 'src/features/myWork';
import { PhoenixSocketProvider } from 'src/features/myWork/context';
import ReviewTabNew from './components/ReviewTabNew';

const MyWorkPage = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0);
  const { isAnalyst } = useRole();

  const isLoadingPendingSubmission = useSelector(selectors.isLoadingPendingSubmission);
  const isIdlePendingSubmission = useSelector(selectors.isIdlePendingSubmission);
  const token = useSelector(selectors.token);
  const dispatch = useDispatch();
  const hasSpecialtyQueueAccess = useSpecialtyQueueAccess();

  useEffect(() => {
    dispatch(getPendingReviewEntryThunk());
  }, [dispatch]);

  useEffect(() => {
    if (hasSpecialtyQueueAccess) {
      dispatch(getSpecialtyQueuePendingCountThunk());
    }
  }, [dispatch, hasSpecialtyQueueAccess]);

  useEffect(() => {
    dispatch(getSocketTokenThunk());
  }, [dispatch]);

  return (
    <ViewPage title="My Work">
      <PhoenixSocketProvider token={token ?? ''}>
        <div className="Container">
          <MultiTab
            name="MyWorkPageTab"
            selectedIndex={activeTab}
            onSelect={(index) => setActiveTab(index as number)}
          >
            <TabHeader aria-label="My Work Tab">
              <TabTitle>Review</TabTitle>
              {isAnalyst && <TabTitle>Performance</TabTitle>}
            </TabHeader>
            <TabBody>
              <TabContent>
                <ReviewTabNew isLoading={isIdlePendingSubmission || isLoadingPendingSubmission} />
              </TabContent>
              {isAnalyst && (
                <TabContent>
                  <MyWorkPerformancePage />
                </TabContent>
              )}
            </TabBody>
          </MultiTab>
        </div>
      </PhoenixSocketProvider>
    </ViewPage>
  );
};

export default MyWorkPage;
